import React, { useState } from "react";

// import JS files
import PanelTemplate from "../../../shares/PanelTemplate";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";
import TabThree from "./TabThree";
import TabThreeFirst from "./TabThreeFirst";

const ProviderCurrentOrders = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      <PanelTemplate sidebarActiveLink="p-progress-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های جاری</span>
          </div>
          <div className="mt-8 flex items-center">
            <span
              className={activeTab == "1" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("1")}
            >
              براساس سند
            </span>
            <span
              className={activeTab == "2" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("2")}
            >
              براساس النگو
            </span>
            <span
              className={activeTab == "3" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("3")}
            >
              براساس کسری
            </span>
            <span
              className={activeTab == "4" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("4")}
            >
              براساس تجمیعی
            </span>
          </div>
          <div
            style={{ backgroundColor: "#fefcfb" }}
            className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
          >
            {activeTab == "1" ? (
              <TabOne />
            ) : activeTab == "2" ? (
              <TabTwo />
            ) : activeTab == "3" ? (
              <TabThreeFirst />
            ) : (
              <TabThree />
            )}
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default ProviderCurrentOrders;
